import { Button, ButtonIconWithLabel, ButtonProps, Icon_OpenNew24 } from "@shapr3d/frontend-lib";

import { useProject } from "../../hooks/useProject";
import { useTracker } from "../../hooks/useTracker";
import { useDeepLinkStateStore } from "../../stores/deepLinkStateStore";

export const DeepLinkButton: React.FC<ButtonProps> = ({ ...args }) => {
  const tracker = useTracker();

  const { setIsModalOpen } = useDeepLinkStateStore();
  const { data: projectData } = useProject();

  if (!projectData) {
    return null;
  }

  return (
    <Button
      variant="grayscale"
      {...args}
      onClick={() => {
        tracker.trackDeeplinkButtonClicked({ projectId: projectData.project.projectId });
        setIsModalOpen(true);
      }}
    >
      {args.children ?? <ButtonIconWithLabel icon={<Icon_OpenNew24 />} label="Open in Shapr3D" />}
    </Button>
  );
};
